import React, { useLayoutEffect } from 'react';
import { Grid } from '@material-ui/core';
import PropTypes from 'prop-types';
import StepNavigationAmount from '../../../MUI/StepNavigationAmount';
import StepsNavigation from '../../../StepsNavigation';
import { MAIN_BUTTON_WIDTH_KEYS } from '../../../MUI/MainButton';

const Navigation = ({
  setStepNavigationBox,
  isDeviceLgSize,
  handleOpenMobileSummary,
  totalPrice,
  handleSubmit,
  next,
  errorsLength,
}) => {
  useLayoutEffect(() => {
    setStepNavigationBox(() => (
      <>
        {isDeviceLgSize && (
        <Grid container spacing={2} alignItems="center" onClick={handleOpenMobileSummary}>
          <StepNavigationAmount amount={totalPrice} iconDown={false} isMobile={isDeviceLgSize} />
        </Grid>
        )}
        <StepsNavigation
          next={handleSubmit(next)}
          isNextDisabled={!!errorsLength}
          width={isDeviceLgSize ? MAIN_BUTTON_WIDTH_KEYS.FULL_WIDTH : ''}
        />
      </>
    ));
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [isDeviceLgSize, errorsLength, handleSubmit, totalPrice]);

  return null;
};

Navigation.propTypes = {
  setStepNavigationBox: PropTypes.func.isRequired,
  isDeviceLgSize: PropTypes.bool.isRequired,
  handleOpenMobileSummary: PropTypes.func.isRequired,
  totalPrice: PropTypes.number.isRequired,
  handleSubmit: PropTypes.func.isRequired,
  next: PropTypes.func.isRequired,
  errorsLength: PropTypes.number.isRequired,
};

export default Navigation;
